import Button from 'components/shared/Button'
import React from 'react'
import s from './BookingCheckout.module.scss'
import useGetPromocodes from 'sdk/hooks/shop/useGetPromocodes'
import useIsAuth from 'sdk/hooks/useIsAuth'

const Promocode = () => {
    const { data: isAuthData } = useIsAuth();
    const userId = isAuthData?.user?.id
    const { data: promocodes } = useGetPromocodes(userId, 'booking');

    return (
        <div className={s.promocode}>
            <input className={s.promocode_field} type="text" placeholder='PROMO CODE' />
            <Button secondarySmall yellow>APPLY</Button>
        </div>
    )
}

export default Promocode
